import "./OTCContact.scss";
import { useTranslation } from "react-i18next";
import contactPhoto from "../../assets/images/contactPhoto.png";
import telegramContact from "../../assets/images/telegramContact.svg";
import linkedinContact from "../../assets/images/linkedinContact.svg";
import whatsAppContact from "../../assets/images/whatsAppContact.svg";

const OTCContact = () => {
  const { t } = useTranslation();

  return (
    <div className="otc-contact">
      <div className="otc-contact-header">
        <h1 className="main-title">{t("subtitles.exchangeSubtitle1")}</h1>
        <div className="sub-title">{t("subtitles.exchangeSubtitle3")}</div>
      </div>
      <div className="contact-block">
        <img src={contactPhoto} alt="photo" className="avatar" />
        <div className="contact-info">
          <div className="contact-title">{t("subtitles.talkTo")}</div>
          <div className="contact-text">{t("subtitles.otcSpecialist")}</div>
        </div>
        <div className="social-links">
          <a href="https://t.me/+48660441569" target="_blank" rel="noreferrer">
            <img src={telegramContact} alt="telegram"></img>
          </a>
          <a href="https://wa.me/48660441569" target="_blank" rel="noreferrer">
            <img src={whatsAppContact} alt="whatsApp"></img>
          </a>
          <a
            href="https://www.linkedin.com/in/bogdantsevd"
            target="_blank"
            rel="noreferrer"
          >
            <img src={linkedinContact} alt="linkendin"></img>
          </a>
        </div>
      </div>
    </div>
  );
};

export default OTCContact;
